import i18n from '../../i18n/i18n.js'
console.log(545455)
console.log(i18n)
const config={
    options: [{
        value: 'TW',
        label: i18n.t("h5.DSX_index_tw")
      }, {
        value: 'MY',
        label: i18n.t("h5.DSX_index_my")
      }, {
        value: 'TH',
        label: i18n.t("h5.DSX_index_th")
      }, {
        value: 'SG',
        label: i18n.t("other.a2232")
      }, {
        value: 'VN',
        label: i18n.t("h5.DSX_index_vn")
      }, {
        value: 'PH',
        label: i18n.t("h5.DSX_index_ph")
      }, {
        value: 'BZ',
        label: i18n.t("h5.DSX_index_bz")
      }, {
        value: 'ID',
        label: i18n.t("h5.DSX_index_id")
      }],
value: '',
isShow:
  {
   authorization:true,
   Pendingorder:false,
   Orderprocessed:false,
   mygoods:false,
   Boundgoods:false,
  },
isShop:false,
isOrder:true,
allShopList:[],
showChare:false,
dialogVisible01: false,
dialogVisible02: false,
dialogVisible03: false,
dialogVisible04: false,
storeAccount:'',
warehouseName:'',
pointsInfomationNum:0,
storeList:JSON.parse(localStorage.getItem('userInfo')).storeIds,
chooseAll:false,
chooseStoreAll:false,
password:'',
chatsRadios:null,
intergralPop:false,
sellerIdList:[],
shopIds:JSON.parse(localStorage.getItem('userInfo')).shopIds,
password01:'',
shopIdttp:'',
start_time:'',
end_time:'',
pagesize:50,
page:0,
pointsInfomation:[],
currentPage4:1,
warehouselist:[],
userName:'',
storeName:'',
stroeIDvalue:'',
shopsalesVisible:false,
level: JSON.parse(localStorage.getItem('userInfo')).vipLevel,
intergralDia:false,
tableData2: [{
        date: '仓租费',
        name: '110',
       
      }, {
        date: '上架费',
        name: '120',
       
      }, {
        date: '打包费',
        name: '123',
       
      }],
pickerOptions2: {
        shortcuts: [{
          text: i18n.t("other.a130"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: i18n.t("other.a131"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: i18n.t("other.a132"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
     
      value4: [],
storeCharge:{
  title: {
      text: '仓库扣费明细',
      subtext: '2021-01',
      left: 'center'
  },
  tooltip: {
      trigger: 'item'
  },
  legend: {
      orient: 'vertical',
      left: 'left',
  },
  series: [
      {
          name: '访问来源',
          type: 'pie',
          radius: '50%',
          data: [
              {value: 1048, name: '仓租费',itemStyle:{color:'rgb(238, 102, 102)'}},
              {value: 735, name: '上架费',itemStyle:{color:'#315dfb'}},
              {value: 580, name: '打包费',itemStyle:{color:'rgb(145, 204, 117)'}},
             
          ],
          emphasis: {
              itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
          }
      }
  ],

},

pay_Value:null,
changType:false,
pointsInfomation_Copy:[],
gridData:[]
}
export default config	